<!--suppress JSUnresolvedReference -->
<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *    type?: string,
     *    id?: string | null,
     *    label?: string | null,
     *    disabled?: boolean,
     *    color?: boolean | string,
     *    ask?: string | null,
     *    small?: boolean,
     *    onclick?: ((event: MouseEvent) => void) | null,
     *    [key: string]: any,
     * }}
     */
    let {
        type = 'button',
        id = null,
        label = '',
        disabled = false,
        color = false,
        ask = null,
        small = false,
        onclick = null,
        ...restProps
    } = $props();

    /** @type {{ [key: string]: string }} */
    const allowedTypes = {
        button: 'button',
        submit: 'submit',
        link: 'a',
    };

    const useType = $derived(ValueService.toStringSingleLine(type));
    const useLabel = $derived(ValueService.toStringSingleLine(label));
    const userSmall = $derived(ValueService.toBool(small));
    const useId = $derived(
        ValueService.hasValue(id) ? ValueService.toStringSingleLine(id) : `ly-button-${crypto.randomUUID()}`
    );
    const useColor = $derived.by(() => {
        if (color === true) {
            return 'secondary';
        }

        if (color !== false && ValueService.hasValue(color)) {
            return ValueService.toStringSingleLine(color);
        }

        return 'primary';
    });

    const thisType = $derived(allowedTypes[useType] ?? 'button');
    const thisTag = $derived(thisType === 'a' ? 'a' : 'button');

    /**
     * @type {{
     *     id: string,
     *     type: string,
     *     disabled: boolean,
     * }}
     */
    const inputProps = $derived({
        id: useId,
        type: thisType,
        disabled: ValueService.toBool(disabled),
    });

    /**
     * @param {MouseEvent} event
     */
    function handleClick(event) {
        if (ValueService.hasValue(ask) && ask !== null && !window.confirm(ask)) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }

        onclick?.(event);
    }
</script>

<svelte:element
    this={thisTag}
    {...restProps}
    {...inputProps}
    onclick={handleClick}
    class={`lyButton mt-2 mr-0 mb-0 ml-1 inline-block rounded-sm px-2 py-1 first:ml-0
        ${userSmall ? 'min-w-24' : 'min-w-48'}
        bg-${useColor}-300 text-${useColor}-900 disabled:bg-black-50
        disabled:text-black-300 cursor-pointer
        font-bold outline-0 hover:ring
        focus:ring`}>
    {useLabel === '' ? 'Button' : useLabel}
</svelte:element>
